export var RECIPIENTS_EVENTS;
(function (RECIPIENTS_EVENTS) {
    RECIPIENTS_EVENTS["USERS_LIST_UNMOUNT"] = "users-list-unmount";
    RECIPIENTS_EVENTS["REMOVE_DECISION_MAKER"] = "remove-decision-maker";
    RECIPIENTS_EVENTS["UPDATE_DECISION_MAKERS"] = "update-decision-makers";
    RECIPIENTS_EVENTS["ADD_DECISION_MAKER"] = "add-decision-maker";
    RECIPIENTS_EVENTS["UPDATE_SUPERVISOR"] = "update-supervisor";
})(RECIPIENTS_EVENTS || (RECIPIENTS_EVENTS = {}));
